"use client";
import { PropsWithChildren, useEffect } from "react";

type MenuProviderProps = PropsWithChildren<{}>;
export const AppProvider = ({ children }: MenuProviderProps) => {
  const suffixCopy = (event: ClipboardEvent) => {
    if (window.customCopyInProgress) return;
    const selection = document.getSelection();
    event?.clipboardData?.setData(
      "text/plain",
      `${selection?.toString()} [Original source: ${window.location.href}]`
    );
    event.preventDefault();
  };

  useEffect(() => {
    document.body.addEventListener("copy", suffixCopy);

    () => {
      document.body.removeEventListener("copy", suffixCopy);
    };
  }, []);

  return <>{children}</>;
};
